'use client';

import { c as _c } from "react/compiler-runtime";
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
export function SanitizedHtml(t0) {
  const $ = _c(5);
  const {
    html
  } = t0;
  const [sanitized, setSanitized] = useState("");
  let t1;
  let t2;
  if ($[0] !== html) {
    t1 = () => {
      setSanitized(DOMPurify.sanitize(html));
    };
    t2 = [html];
    $[0] = html;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!sanitized) {
    return null;
  }
  let t3;
  if ($[3] !== sanitized) {
    t3 = <span dangerouslySetInnerHTML={{
      __html: sanitized
    }} />;
    $[3] = sanitized;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}